<mb-products-teaser-component
  [references$]="references$"
  [title]="title"
  [dataAnalyticsClickSource]="dataAnalyticsClickSource"
  [dataAnalyticsEventLabel]="dataAnalyticsEventLabel"
></mb-products-teaser-component>
